<template>
  <div class="product">
    <div class=" column order-locker mb-2">
        <img class=" rounded" :src="theItem.image" alt="image">
    </div>
    <div class="column mb-1">{{theItem.name}}</div>
    <div class="column mb-1">{{theItem.number}}</div>
    <div class="column mb-1">{{theItem.price}} تومان</div>
  </div>
</template>
<script>
import { ref } from "@vue/composition-api";
export default {
  props: ["theItem"],
};
</script>
<style scoped>
/* td {
  border-top: 1px solid rgba(127, 127, 127, 0.2);
  white-space: nowrap;
  text-align: center;
} */

tr {
  width: 100%;
}

.order-locker img{
    width: 80px;
}
.product{
  white-space: nowrap;
}

</style>